import { useState } from 'react'
import { Copy, Check } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface Props {
  value: string
  label?: string
}

export default function CopyableValue({ value, label }: Props) {
  const { t } = useTranslation('common')
  const [copied, setCopied] = useState(false)

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      /* clipboard puede fallar en http no-localhost o sin permisos */
    }
  }

  return (
    <div>
      {label && <div className="text-xs t-muted mb-1.5">{label}</div>}
      <div className="flex items-center gap-2">
        <code className="flex-1 px-3 py-2 rounded-lg bg-[var(--bg-input)] border border-slate-700/60 font-mono text-sm text-jr2-700 dark:text-jr2-200 break-all">
          {value}
        </code>
        <button
          type="button"
          onClick={copy}
          className="px-3 py-2 rounded-lg bg-[var(--bg-hover)] hover:bg-slate-800 t-secondary flex items-center gap-1.5 text-sm"
        >
          {copied ? <Check size={14} className="text-emerald-400" /> : <Copy size={14} />}
          {copied ? t('copyableValue.copied') : t('copyableValue.copy')}
        </button>
      </div>
    </div>
  )
}
